<template>
    <div class="p-10 mb-10 bg-mimer-gray flex flex-col items-center text-sm md:text-base">
        <b>Hur många är ni i hushållet?</b>
        <div class="sm:w-1/2 lg:w-1/3">
            <p v-if="currentApplicantProfile != null">
                Innan du kan anmäla intresse behöver vi veta hur många som ska bo i lägenheten. Du har tidigare angett
                att ni är
                {{ convertToNumeral(currentApplicantProfile.numAdults + currentApplicantProfile.numChildren) }}
                ({{ currentApplicantProfile.numAdults + currentApplicantProfile.numChildren }}) personer i hushållet.
                Stämmer det för din ansökan?
            </p>
            <p v-else>Innan du kan anmäla intresse behöver vi veta hur många som ska bo i lägenheten.</p>
            <div v-if="currentApplicantProfile != null" class="flex pb-4">
                <div class="w-1/4">
                    <input type="radio" id="1" value="1" name="householdCount" @click="toggleCountHousehold(false)" />
                    <label for="1" class="px-2">Ja</label>
                </div>
                <div class="w-1/4">
                    <input type="radio" id="0" value="0" name="householdCount" @click="toggleCountHousehold(true)" />
                    <label for="0" class="px-2">Nej</label>
                </div>
            </div>
            <div v-if="countHousehold" class="flex pb-4 -mx-2">
                <div class="w-1/2 px-2">
                    <label for="adults" class="block uppercase text-sm font-bold mb-2">Antal vuxna</label
                    ><input
                        placeholder="0"
                        id="adults"
                        v-model="inputAdults"
                        type="number"
                        min="1"
                        step="1"
                        onkeydown="if(event.key==='.' || event.key===','){event.preventDefault();}"
                        class="appearance-none block w-full bg-grey-lighter text-grey-darker border border-red rounded py-3 px-4 untouched pristine required" />
                </div>
                <div class="w-1/2 px-2">
                    <label for="children" class="block uppercase text-sm font-bold mb-2">Antal barn</label
                    ><input
                        placeholder="0"
                        id="children"
                        v-model="inputChildren"
                        type="number"
                        class="appearance-none block w-full bg-grey-lighter text-grey-darker border border-red rounded py-3 px-4 untouched pristine required" />
                </div>
            </div>

            <div class="flex items-center justify-center pt-4">
                <div v-if="isLoading" class="mimer-button relative" style="width: 125px; height: 60px">
                    <img src="../../assets/3-dots-scale-white-36.svg" class="absolute w-full top-0 left-0 h-full" />
                </div>
                <div class="w-1/2">
                    <mimer-button @click="saveApplicationProfile()" text="Gå vidare" />
                </div>
            </div>
            <div v-if="errorMessage" class="flex items-center justify-center pt-4">
                <p class="italic pl-2">
                    {{ errorMessage }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { loggedInStatus } from '../../utils/helpers';
import { MimerButton } from 'mimer-components';

export default {
    name: 'SupplyApplicationProfile',

    emits: ['onProfileFetched', 'onProfileSaved'],
    components: {
        MimerButton,
    },
    data() {
        return {
            isLoading: false,
            currentApplicantProfile: null,
            countHousehold: false,
            inputAdults: '',
            inputChildren: 0,
            errorMessage: '',
        };
    },
    methods: {
        toggleCountHousehold(countHousehold) {
            this.countHousehold = !!countHousehold;
        },
        shouldSupplyHouseholdCount() {
            return (
                this.currentApplicantProfile == null ||
                this.currentApplicantProfile.expiresAt < new Date().toISOString()
            );
        },
        async saveApplicationProfile() {
            var adults = this.countHousehold ? this.inputAdults : this.currentApplicantProfile.numAdults;
            var children = this.countHousehold ? this.inputChildren : this.currentApplicantProfile.numChildren;

            this.isLoading = true;

            if (adults < 1) {
                this.errorMessage = 'Du måste ange minst en vuxen.';
                this.isLoading = false;
                return;
            }

            try {
                let response = await axios.post(
                    process.env.VUE_APP_API_URL + '/api/applicants/me/applicantProfile',
                    {
                        numberOfAdults: adults,
                        numberOfChildren: children,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${loggedInStatus()}`,
                        },
                        validateStatus: function () {
                            return true;
                        },
                    }
                );

                this.isLoading = false;
                if (response.status === 200) {
                    this.errorMessage = '';
                    this.$emit('onProfileSaved');
                    return;
                }
            } catch (err) {
                console.error('Failed to save the application profile: ', err);
            }
            this.errorMessage = 'Något gick fel när din boendeprofil skulle sparas, vänligen försök igen.';
            return;
        },
        async fetchApplicantProfile() {
            let profileResp = await axios.get(process.env.VUE_APP_API_URL + '/api/applicants/me/applicantProfile', {
                headers: { Authorization: `Bearer ${loggedInStatus()}` },
            });
            if (profileResp.data && profileResp.data != '') {
                this.currentApplicantProfile = profileResp.data;
                this.inputAdults = this.currentApplicantProfile.numAdults;
                this.inputChildren = this.currentApplicantProfile.numChildren;
            }

            this.toggleCountHousehold(this.currentApplicantProfile == null && this.shouldSupplyHouseholdCount());

            this.$emit('onProfileFetched', this.shouldSupplyHouseholdCount());
        },
        convertToNumeral(m) {
            var numbers = [
                'noll',
                'ett',
                'två',
                'tre',
                'fyra',
                'fem',
                'sex',
                'sju',
                'åtta',
                'nio',
                'tio',
                'elva',
                'tolv',
                'tretton',
                'fjorton',
                'femton',
                'sexton',
                'sjutton',
                'arton',
                'nitton',
                'tjugo',
            ];
            return numbers[m];
        },
    },
    async mounted() {
        await this.fetchApplicantProfile();
    },
};
</script>
